// @ts-nocheck
import * as effects from 'redux-saga/effects';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';
import { getNowDateTimeIso } from '../../../../utils/dateTime';
import { chatActions } from '../../../chat/actions';

export function* handleMessageChart(payload) {
  try {
    yield effects.put(wsActions.setSocketsStatus('MESSAGE'));
    const date = yield effects.call(getNowDateTimeIso);
    const message = {
      id: payload.message_id,
      text: payload.token,
      created_at: date,
      chat: payload.chat_id,
      chart_data: payload.chart_data,
      table_data: payload.table_data,
    };
    yield effects.put(chatActions.createMessage(message));
    yield effects.put(chatActions.stopWaiting());
    // TODO: add message to store

    yield effects.put(chatActions.debounceChat(payload.next_token));
  } catch (e) {
    yield handleError(e);
  }
}
